(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["preview-checkout-offer"] && !Shopify.designMode) return;
  try {
    (() => {
  let expiryTimer;
  const refreshOffers = () => {
    clearTimeout(expiryTimer);
    const now = Date.now();
    let nextExpiry = Infinity;
    document.querySelectorAll('[data-checkout-offer-expires]').forEach(offer => {
      const expires = Date.parse(offer.dataset.checkoutOfferExpires);
      if (!Number.isFinite(expires)) return;
      if (now >= expires) offer.remove();
      else nextExpiry = Math.min(nextExpiry, expires);
    });
    if (Number.isFinite(nextExpiry)) {
      expiryTimer = setTimeout(refreshOffers, Math.min(nextExpiry - now + 50, 2147483647));
    }
  };
  refreshOffers();
  window.addEventListener('pageshow', refreshOffers);
  document.addEventListener('visibilitychange', refreshOffers);
  document.addEventListener('shopify:section:load', refreshOffers);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["preview-header"] && !Shopify.designMode) return;
  try {
    (() => {
  const disclosure = document.querySelector('.contact-disclosure');
  if (!disclosure) return;
  const toggle = disclosure.querySelector('summary');
  const sync = () => {
    toggle.setAttribute('aria-expanded', String(disclosure.open));
  };
  sync();
  disclosure.addEventListener('toggle', sync);
})();
  } catch(e) { console.error(e); }
})();

})();
